// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Js_string from "../../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function splitFullNameJson(fullName) {
  var names = Js_string.split(" ", $$String.trim(fullName));
  var match = names.length;
  if (match === 0) {
    return [
            null,
            null
          ];
  }
  if (match === 1) {
    return [
            names[0],
            null
          ];
  }
  var firstName = names[0];
  var lastName = names[names.length - 1 | 0];
  return [
          firstName,
          lastName
        ];
}

function splitFullName(fullName) {
  var names = Js_string.split(" ", $$String.trim(fullName));
  var match = names.length;
  if (match === 0) {
    return [
            undefined,
            undefined
          ];
  }
  if (match === 1) {
    return [
            names[0],
            undefined
          ];
  }
  var firstName = names[0];
  var lastName = names[names.length - 1 | 0];
  return [
          firstName,
          lastName
        ];
}

function checkErrorIsEmail(error) {
  var message = Js_string.slice(0, 5, error);
  return message.toLowerCase() === "email";
}

function signupGAEventLabel(name, email, whatsapp_consent) {
  if (whatsapp_consent) {
    return name + "_" + email + "_true";
  } else {
    return name + "_" + email + "_false";
  }
}

function mobile(user) {
  if (user !== undefined) {
    return Belt_Option.getWithDefault(user.mobile, "");
  } else {
    return "";
  }
}

function email(user) {
  if (user !== undefined) {
    return user.email;
  }
  
}

function name(user) {
  if (user !== undefined) {
    return user.name;
  }
  
}

function whatsappConsent(user) {
  if (user !== undefined) {
    return user.whatsapp_consent;
  }
  
}

function requirementType(user) {
  if (user !== undefined) {
    return user.requirement_type;
  }
  
}

function optionBoolToJson(value) {
  if (value !== undefined) {
    return value;
  } else {
    return null;
  }
}

function optionStringToJson(text) {
  if (text !== undefined) {
    return text;
  } else {
    return null;
  }
}

export {
  splitFullNameJson ,
  splitFullName ,
  checkErrorIsEmail ,
  signupGAEventLabel ,
  mobile ,
  email ,
  name ,
  whatsappConsent ,
  requirementType ,
  optionBoolToJson ,
  optionStringToJson ,
}
/* No side effect */
